import { Button } from '@/components/ui/button';
import { useLanguage } from '@/i18n/language-hooks';
import { X } from 'lucide-react';
import { useState } from 'react';

interface AppUpdateBannerProps {
  visible: boolean;
  onReload: () => void;
}

export function AppUpdateBanner({ visible, onReload }: AppUpdateBannerProps) {
  const { t } = useLanguage();
  const [dismissed, setDismissed] = useState(false);

  if (!visible || dismissed) {
    return null;
  }

  return (
    <div
      role='status'
      className='border-fin-accent/30 bg-fin-gray-900/95 fixed inset-x-0 bottom-[calc(var(--bottom-nav-height,0px)+0.5rem)] z-50 mx-auto flex max-w-lg items-center gap-3 rounded-xl border px-4 py-3 shadow-lg backdrop-blur-sm md:bottom-4'
    >
      <p className='text-fin-white min-w-0 flex-1 text-sm'>{t('app.updateAvailable')}</p>
      <Button size='sm' onClick={onReload}>
        {t('app.reload')}
      </Button>
      <Button
        type='button'
        variant='ghost'
        size='icon'
        className='size-8 shrink-0'
        onClick={() => setDismissed(true)}
        aria-label={t('common.close')}
      >
        <X className='size-4' />
      </Button>
    </div>
  );
}
